/* eslint consistent-return: "off" */
import { getInstance } from './msal-plugin';

export const authenticationGuard = (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const authService = getInstance();

    const guardAction = () => {
      if (authService.isAuthenticated) return next();

      authService.loginRedirect({ redirectStartPage: `${process.env.VUE_APP_BASE_URL}${to.fullPath}` });
    };

    // if the MsalPlugin has loaded already, check the authentication state
    if (!authService.isLoading) return guardAction();

    authService.$watch('isLoading', (isLoading) => {
      if (isLoading === false) return guardAction();
    });
  } else next();
};

export const homeGuard = (to, from, next) => {
  const authService = getInstance();

  const guardAction = () => {
    if (authService.hasRole('admin') || authService.hasRole('teacher') || authService.hasRole('accountant')) {
      next('/requests');
    } else if (authService.hasRole('student')) {
      next('/student/requests');
    } else {
      next();
    }
  };

  // if the MsalPlugin has loaded already, check the authentication state
  if (!authService.isLoading) return guardAction();

  authService.$watch('isLoading', (isLoading) => {
    if (isLoading === false) return guardAction();
  });
};

export const multiGuard = (to, from, next) => {
  const authService = getInstance();

  const guardAction = () => {
    if (
      (['StudentRequests', 'StudentNewRequest', 'StudentRequestDetails'].includes(to.name) && authService.hasRole('student'))
      || (['Partners', 'Statistics', 'Teachers', 'Companies'].includes(to.name) && authService.hasRole('admin'))
      || (to.name === 'RequestDetails' && (authService.hasRole('admin') || authService.hasRole('teacher')))
      || (to.name === 'RequestList' && (authService.hasRole('admin') || authService.hasRole('teacher') || authService.hasRole('accountant')))
    ) next();
    else next('/');
  };

  // if the MsalPlugin has loaded already, check the authentication state
  if (!authService.isLoading) return guardAction();

  authService.$watch('isLoading', (isLoading) => {
    if (isLoading === false) return guardAction();
  });
};
